import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "../../constant";

const getToken = () => {
  const userToken = localStorage.getItem("userToken");
  return userToken ? `Bearer ${userToken}` : "";
};

const leadApi = createApi({
  reducerPath: "fetchleadapi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    mode: "cors",
    prepareHeaders: (headers) => {
      const token = getToken();
      if (token) {
        headers.set("Authorization", token);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getMyLead: builder.query({
      query: ({ page, id, user_id, leadStatus = null }) => {
        const url = leadStatus
          ? `mylead?status=${leadStatus}&page=${page}&id=${id}&user_id=${user_id}`
          : `mylead?page=${page}&id=${id}&user_id=${user_id}`;
        return {
          url: url,
          method: "GET",
        };
      },
    }),
    getNotInterestedLead: builder.query({
      query: () => ({
        url: `notinterestedlead`,
        method: "GET",
      }),
    }),
    getDeadLead: builder.query({
      query: () => ({
        url: `deadlead`,
        method: "GET",
      }),
    }),
    getPropertType: builder.query({
      query: (interested) => ({
        url: `property-type/${interested}`,
        method: "GET",
      }),
    }),
    getOptionList: builder.query({
      query: () => ({
        url: `static-value`,
        method: "GET",
      }),
    }),
    getLeadDetails: builder.query({
      query: (id) => ({
        url: `mylead/detail/${id}`,
        method: "GET",
      }),
    }),
    pendingLead: builder.query({
      query: (id) => ({
        url: `pendingfollowup?user_id=${id}`,
        method: "GET",
      }),
    }),
    createLead: builder.mutation({
      query: (postLead) => ({
        url: "mylead/create",
        method: "POST",
        body: postLead,
      }),
    }),
    updateLead: builder.mutation({
      query: (postLead) => ({
        url: "mylead/updatestatus",
        method: "POST",
        body: postLead,
      }),
    }),
  }),
});

export const {
  useGetMyLeadQuery,
  useGetNotInterestedLeadQuery,
  useGetDeadLeadQuery,
  useGetLeadDetailsQuery,
  useGetOptionListQuery,
  useGetPropertTypeQuery,
  useCreateLeadMutation,
  useUpdateLeadMutation,
  usePendingLeadQuery,
} = leadApi;
export default leadApi;
